import styles from './Carousel.module.css'

/** Shared horizontal, snap-scrolling row used by the product-page card carousels. */
const Carousel: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles.row}>{children}</div>
)

export default Carousel
